var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('page-loader',{attrs:{"show":_vm.loading,"text":_vm.loadingText}}),_c('div',{staticClass:"main"},[_c('router-view')],1),_c('page-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }